// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2820": "b6025241b1d2","3571": "bb0d7aea5624","4569": "63d2066c4163","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}